import { FileUploader } from 'react-drag-drop-files'
import { GetImages } from '../../../utils/GetImages'
import { DocumentService } from '@propertelligent/client-api';
import apiHelper from '../../../utils/apiHelper';
import { useError } from '../../../utils/context/ErrorContext';

const DragAndDropUploader = ({ handleChange, docsArr, setDocsArr, name, maxFiles = undefined }) => {
  const { errors, errorMessages } = useError();
  const isAtLimit = maxFiles !== undefined && docsArr.length >= maxFiles;
  // docsArr is the caller's per-type subset; update the full list so other types' files survive.
  const handleDelete = (id, index) => {
    if (id) {
      apiHelper(DocumentService.deleteApiDocument, { showNotification: false }, id)
        .then((res) => {
          if (res?.data?.success) {
            setDocsArr((prev) => prev.filter((doc) => doc.id !== id));
          }
        })
    } else {
      const removed = docsArr[index];
      setDocsArr((prev) => prev.filter((doc) => doc !== removed));
    }
  };

  return (
    <>
      <div className="dragAndDropUploader_main ">
        <p className="normal_text"> {name} <span className='red'>*</span></p>
        {!isAtLimit && (
        <FileUploader
          handleChange={handleChange}
          classes="fileuploaderbutton clickable"
          children={
            <>
              <div className="dragAndDropUploader">
                <img width={24} height={24} src={GetImages.upload} />
                <div>
                  <p className='normal_text fw-600'> Drag & Drop or <span className="blue"> Browse </span></p>
                  <p className='normal_text'> .pdf, .png, .jpeg; Max file size: 1mb</p>
                </div>
              </div>
            </>
          }
        />
        )}
        {docsArr.length > 0 && (
          <div
            className="fileDeleteSection rent-doc-list">
            {docsArr.map((doc, index) => (
              <div
                key={index}
                className="documentContainerEditForm"
              >
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <img width={20} height={24} src={GetImages.pdfImage} />
                  <p
                    className="licenseDocumentText"
                    title={doc?.fileName}>
                    {doc?.fileName}
                  </p>
                </div>
                <img
                  width={20}
                  height={20}
                  onClick={() => handleDelete(doc?.id, index)}
                  src={GetImages.deleteIconRed}
                  style={{ cursor: "pointer" }}
                />
              </div>
            ))}
          </div>
        )}

        {(errors.FileType || errors.FileSize) && (
          <div style={{ marginTop: "8px" }}>
            {errors.FileType && (
              <p className="errorMessageStyles">{errorMessages.FileType}</p>
            )}
            {errors.FileSize && (
              <p className="errorMessageStyles">{errorMessages.FileSize}</p>
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default DragAndDropUploader